import { MoneyDTO } from '../../../../../../system/system-dtos';

export interface PlayerBalanceDTO {
  cash: MoneyDTO;
  reserve: MoneyDTO;
  bonus?: PlayerBonusBalanceDTO;
  diamonds: DiamondsBalanceDTO;
}

export interface DiamondsBalanceDTO {
  balance: number;
  redeem: number;
}

export class PlayerBonusBalanceDTO {
  id: number;
  name: string;
  balance: MoneyDTO;
}

export class AdjustPlayerBonusDTO {
  id: number;
  delta: MoneyDTO;
}

export interface AdjustPlayerBalanceDTO {
  type: AdjustmentTypeCode;
  cashDelta?: MoneyDTO;
  reserveDelta?: MoneyDTO;
  bonus?: AdjustPlayerBonusDTO;
  diamondsDelta?: number;
  internalReason: string;
  externalReason: string;
  references?: string;
}

export enum AdjustmentTypeCode {
  TESTING_FUNDS = 'TESTING_FUNDS',
  FRAUD = 'FRAUD',
  CHARITY = 'CHARITY',
  DISCRETIONARY = 'DISCRETIONARY',
  MANUAL_OFFER = 'MANUAL_OFFER',
  TECHNICAL_ISSUE = 'TECHNICAL_ISSUE',
}
